import { Check, Plus } from "lucide-react";

const money = (n) => `S$${Number(n).toFixed(Number(n) % 1 ? 2 : 0)}`;

const Chip = ({ active, onClick, children, testid }) => (
    <button
        type="button"
        onClick={(e) => { e.stopPropagation(); onClick(); }}
        className={`inline-flex items-center gap-2 px-3 py-2 text-xs rounded-full border transition-colors ${active ? "border-[#6B1535] bg-[#6B1535] text-[#FFF8F2]" : "border-[#C29A5B]/50 bg-white text-[#3D0C1F] hover:border-[#6B1535]"}`}
        data-testid={testid}
    >
        {children}
    </button>
);

export const BookingServiceRow = ({ s, selected, variantId, addonIds = [], open, onToggle, onPickVariant, onToggleAddon }) => {
    const variants = s.variants || [];
    const addons = s.addons || [];
    const chosen = variants.find((v) => v.id === variantId);
    const op = Number(s.original_price) || 0;
    const hasDiscount = !variants.length && op > Number(s.price);
    const price = chosen ? money(chosen.price) : variants.length ? `from ${money(Math.min(...variants.map((v) => Number(v.price))))}` : money(s.price);
    const showVariants = variants.length > 0 && (open || selected);
    return (
        <div className={`border-b border-[#6B1535]/10 transition-colors ${selected ? "bg-[#6B1535]/[0.04]" : ""}`} data-testid={`booking-service-${s.id}`}>
            <button type="button" onClick={onToggle} className="w-full flex items-center gap-4 py-4 px-2 text-left" data-testid={`booking-service-toggle-${s.id}`}>
                <span className="flex-1 min-w-0">
                    <span className="block text-[#3D0C1F] text-[0.95rem] sm:text-base leading-snug">{s.name}</span>
                    {chosen && <span className="block text-xs text-[#8F622C] mt-0.5">{chosen.name}</span>}
                </span>
                <span className="text-right shrink-0">
                    <span className="block text-sm font-medium text-[#3D0C1F]" data-testid={`booking-service-price-${s.id}`}>{price}</span>
                    {hasDiscount && <span className="block text-[0.7rem] text-[#8A6574] line-through">{money(op)}</span>}
                </span>
                <span className={`shrink-0 w-9 h-9 rounded-full flex items-center justify-center border transition-all ${selected ? "bg-[#6B1535] border-[#6B1535] text-[#FFF8F2] scale-105" : "border-[#C29A5B] text-[#6B1535]"}`} aria-hidden>
                    {selected ? <Check size={16} /> : <Plus size={16} />}
                </span>
            </button>
            {showVariants && (
                <div className="px-2 pb-4 -mt-1" data-testid={`variant-picker-${s.id}`}>
                    {!chosen && <div className="text-[0.65rem] tracking-[0.18em] uppercase text-[#6B1535] mb-2">Choose an option</div>}
                    <div className="flex flex-wrap gap-2">
                        {variants.map((v) => (
                            <Chip key={v.id} active={v.id === variantId} onClick={() => onPickVariant(v.id)} testid={`variant-${s.id}-${v.id}`}>
                                {v.name} <span className="opacity-80">{money(v.price)}</span>
                            </Chip>
                        ))}
                    </div>
                </div>
            )}
            {selected && addons.length > 0 && (
                <div className="px-2 pb-4 -mt-1" data-testid={`addon-picker-${s.id}`}>
                    <div className="text-[0.65rem] tracking-[0.18em] uppercase text-[#7A5262] mb-2">Add extras (optional)</div>
                    <div className="flex flex-wrap gap-2">
                        {addons.map((a) => (
                            <Chip key={a.id} active={addonIds.includes(a.id)} onClick={() => onToggleAddon(a.id)} testid={`addon-${s.id}-${a.id}`}>
                                {addonIds.includes(a.id) ? <Check size={12} /> : <Plus size={12} />} {a.name} <span className="opacity-80">+{money(a.price)}</span>
                            </Chip>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export const BookingPackageRow = ({ p, selected, onToggle }) => (
    <div className={`border-b border-[#6B1535]/10 ${selected ? "bg-[#6B1535]/[0.04]" : ""}`} data-testid={`booking-package-${p.id}`}>
        <button type="button" onClick={onToggle} className="w-full flex items-center gap-4 py-4 px-2 text-left" data-testid={`booking-package-toggle-${p.id}`}>
            <span className="flex-1 min-w-0 text-[#3D0C1F] text-[0.95rem] sm:text-base leading-snug">{p.name}</span>
            <span className="text-sm font-medium text-[#3D0C1F] shrink-0">{money(p.price)}</span>
            <span className={`shrink-0 w-9 h-9 rounded-full flex items-center justify-center border ${selected ? "bg-[#6B1535] border-[#6B1535] text-[#FFF8F2]" : "border-[#C29A5B] text-[#6B1535]"}`} aria-hidden>
                {selected ? <Check size={16} /> : <Plus size={16} />}
            </span>
        </button>
    </div>
);
